import { useContext } from 'react';
import { SelectContext } from '../../contexts';

export function useSelect() {
  const context = useContext(SelectContext);

  return context;
}
